// extracted by mini-css-extract-plugin
export default {"tooltip":"LP-z","arrow":"MP-z"};